import styles from '~/styles/components/author/author-links.module.scss';
import Link from 'next/link';
import { Author } from 'types';

import EditFilledSVG from '~/assets/svg/icons/edit-filled';
import TwitterIconSVG from '~/assets/svg/icons/twitter-icon';
import InstaIconSVG from '~/assets/svg/icons/instagram-icon';
import WebIconSVG from '~/assets/svg/icons/web-icon';
import COLORS from '~/lib/helpers/color-helper';

import { ActionType } from '~/state/types';
import { useGlobalState } from '~/state';
import Button from '~/components/button';
import Input from '~/components/form/input';
import InputLabel from '~/components/input-label';
import { updateFirestoreDoc } from '~/clients/firebase/client';
import { useState } from 'react';

interface AuthorLinksProps {
  author: Author;
  user: any;
  isAdmin: boolean;
}

export default function AuthorLinks({
  author,
  user,
  isAdmin,
}: AuthorLinksProps) {
  const { dispatch } = useGlobalState();

  function EditAuthorLinks() {
    const [twitter, setTwitter] = useState(author?.twitter || '');
    const [instagram, setInstagram] = useState(author?.instagram || '');
    const [website, setWebsite] = useState(author?.website || '');

    async function handleSaveLinks() {
      try {
        await updateFirestoreDoc('author_content', author.id, {
          twitter: twitter,
          instagram: instagram,
          website: website,
          updated_by: user?.name,
          updated_at: new Date(),
        });
      } catch (error) {
        console.log(error);
      }
      dispatch({
        type: ActionType.FLUSH_MODAL_DATA,
      });
    }

    return (
      <div>
        <div className={styles['edit-author-links-container']}>
          <div className={styles['edit-author-links-body']}>
            <div className={styles['edit-author-links-item']}>
              <div className={styles['edit-author-links-label']}>
                <InputLabel>Twitter</InputLabel>
              </div>
              <div className={styles['edit-author-links-input']}>
                <Input
                  type='text'
                  name='twitter'
                  className={styles['edit-author-links-input']}
                  onChange={(e) => setTwitter(e.target.value)}
                  value={twitter}
                  required
                />
              </div>
            </div>

            <div className={styles['edit-author-links-item']}>
              <div className={styles['edit-author-links-label']}>
                <InputLabel>Instagram</InputLabel>
              </div>
              <div className={styles['edit-author-links-input']}>
                <Input
                  type='text'
                  name='instagram'
                  className={styles['edit-author-links-input']}
                  onChange={(e) => setInstagram(e.target.value)}
                  value={instagram}
                  required
                />
              </div>
            </div>
            <div className={styles['edit-author-links-item']}>
              <div className={styles['edit-author-links-label']}>
                <InputLabel>Website</InputLabel>
              </div>
              <div className={styles['edit-author-links-input']}>
                <Input
                  type='text'
                  name='website'
                  className={styles['edit-author-links-input']}
                  onChange={(e) => setWebsite(e.target.value)}
                  value={website}
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <Button
          className={styles['button']}
          size='small'
          style='primary'
          type='submit'
          text='save'
          onPress={(e) => handleSaveLinks()}
        />
      </div>
    );
  }

  function handleAuthorLinks(event: any) {
    dispatch({
      type: ActionType.ADD_MODAL_DATA,
      payload: {
        title: `Edit Social Links`,
        component: <EditAuthorLinks />,
      },
    });
  }

  return (
    <div className={styles['container']}>
      {isAdmin && (
        <div
          className={styles['edit-icon-container']}
          onClick={handleAuthorLinks}
        >
          <EditFilledSVG />
        </div>
      )}
      <div className={styles['icons-container']}>
        {author?.twitter && (
          <Link
            href={author?.twitter}
            passHref
            className={styles.icons}
            target='_blank'
            rel='noopener noreferrer'
            aria-label={`Visit ${author}'s Twitter page`}
          >
            <TwitterIconSVG fillColor={COLORS.primary} />
          </Link>
        )}
        {author?.instagram && (
          <Link
            href={author?.instagram}
            passHref
            className={styles.icons}
            target='_blank'
            rel='noopener noreferrer'
            aria-label={`Visit ${author}'s Instagram page`}
          >
            <InstaIconSVG fillColor={COLORS.primary} />
          </Link>
        )}
        {author?.website && (
          <Link
            href={author?.website}
            passHref
            className={styles.icons}
            target='_blank'
            rel='noopener noreferrer'
            aria-label={`Visit ${author}'s website`}
          >
            <WebIconSVG strokeColor={COLORS.primary} fillColor='transparent' />
          </Link>
        )}
      </div>
    </div>
  );
}
